import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import supabase from "../config/supabaseClient";
import "../index2.css";

const InsertAdversaryEventPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const gameId = new URLSearchParams(location.search).get("gameId");

  const [number, setNumber] = useState("");
  const [eventType, setEventType] = useState("");
  const [minute, setMinute] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    if (!number || !eventType || !minute) {
      setError("Please fill out all fields.");
      return;
    }

    try {
      setSaving(true);

      const { error } = await supabase.from("adv_event").insert([
        {
          game_id: gameId,
          number: parseInt(number, 10),
          event: eventType,
          minute: parseInt(minute, 10),
        },
      ]);

      if (error) throw error;

      setSuccess(true);
      setNumber("");
      setEventType("");
      setMinute("");
    } catch (err) {
      setError("Error saving event: " + (err.message || "Unknown error"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page insert-adversary-event">
      <button onClick={() => navigate(-1)} className="back-button">
        Back
      </button>
      <h2>Add Adversary Event</h2>

      {error && <p className="error">{error}</p>}
      {success && <p className="success">Event added successfully!</p>}

      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          width: "300px",
          margin: "20px auto",
        }}
      >
        <label>
          Player Number:
          <input
            type="number"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            placeholder="e.g. 10"
            required
            style={{ width: "100%", padding: "5px" }}
          />
        </label>

        <label>
          Event Type:
          <select
            value={eventType}
            onChange={(e) => setEventType(e.target.value)}
            required
            style={{ width: "100%", padding: "5px" }}
          >
            <option value="">Select event</option>
            <option value="Goal">⚽ Goal</option>
            <option value="Yellow Card">🟨 Yellow Card</option>
            <option value="Red Card">🟥 Red Card</option>
          </select>
        </label>

        <label>
          Minute:
          <input
            type="number"
            value={minute}
            onChange={(e) => setMinute(e.target.value)}
            placeholder="e.g. 67"
            required
            style={{ width: "100%", padding: "5px" }}
          />
        </label>

        <button
          type="submit"
          disabled={saving}
          style={{
            padding: "10px",
            background: "#8B0000",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          {saving ? "Saving..." : "Add Event"}
        </button>
      </form>
    </div>
  );
};

export default InsertAdversaryEventPage;
